import { render, staticRenderFns } from "./RelatedCaseList.vue?vue&type=template&id=07a4d1c6&"
import script from "./RelatedCaseList.vue?vue&type=script&lang=js&"
export * from "./RelatedCaseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports